import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import { useIntl } from 'react-intl';

const DownloadFilesListHeader = ({
  orderBy,
  order,
  allFilesSelected,
  currentStatus,
  handleChangeOrder,
  handleSelectAllFiles,
}) => {
  const intl = useIntl();

  const changeOrder = (e, field) => {
    e.preventDefault();
    handleChangeOrder(field, order === 'asc' ? 'desc' : 'asc');
  };

  return (
    <tr>
      {currentStatus === 'accepted' && (
        <th className="selector">
          <Input
            type="checkbox"
            className="input-check check-s form-check-input"
            checked={allFilesSelected}
            onChange={handleSelectAllFiles}
          />
        </th>
      )}
      <th>{' '}</th>
      <th className={`th-sortable${orderBy === 'name' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'name'); }}>
          {intl.formatMessage({ defaultMessage: 'File Name' })}
          {' '}
          {orderBy === 'name' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Owner' })}
      </th>
      <th className={`th-sortable${orderBy === 'created_at' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'created_at'); }}>
          {intl.formatMessage({ defaultMessage: 'Uploaded' })}
          {' '}
          {orderBy === 'created_at' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      {currentStatus === 'accepted' && (
        <th>{' '}</th>
      )}
    </tr>
  );
};

DownloadFilesListHeader.propTypes = {
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  allFilesSelected: PropTypes.bool.isRequired,
  currentStatus: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
  handleSelectAllFiles: PropTypes.func.isRequired,
};

export default DownloadFilesListHeader;
